import { createGlobalState } from 'react-hooks-global-state';

const { GlobalStateProvider, useGlobalState } = createGlobalState({
  currentChannel: 'main',
  unreadCountByChannel: {},
  messagesByChannel: null,
  summaryVotesById: {},
});

export {
  GlobalStateProvider,
  useGlobalState,
}